module.exports = __webpack_public_path__ + "2936a3fbdc5d530efcc8e9af9d8c0f8f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/sorted-bw.svg
// module id = 118
// module chunks = 0